import axios from "axios";
import store from "../redux/store";
import { setIsLoggedIn } from "../redux/slices/isLoggedInSlice";
import publicApi from "./publicApi";
import { setRole } from "../redux/slices/roleSlice";

const API_URL = process.env.REACT_APP_API_URL

if (!API_URL) { console.error("❌ API URL is missing"); }


const privateApi = axios.create({
  baseURL: `${API_URL}`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Add response interceptor to handle 401 responses
privateApi.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await publicApi.post("/api/auth/refresh");
        store.dispatch(setRole(refreshResponse.data.role));

        return privateApi(originalRequest); // retry original request
      } catch (refreshError) {
        store.dispatch(setIsLoggedIn(false));

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default privateApi;